var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute",style:({ 'top': _vm.top + 'px', 'right': _vm.right + 'px', 'z-index': _vm.zIndex })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }